var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInaccurateContent72(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#FFF6E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5308 24.6001H25.5C23.2909 24.6001 21.5 26.391 21.5 28.6001V42.8408C21.5 45.05 23.2909 46.8408 25.5 46.8408H27.1308V53.4001L36.5154 46.8408H47.5308C49.7399 46.8408 51.5308 45.05 51.5308 42.8408V28.6001C51.5308 26.391 49.7399 24.6001 47.5308 24.6001Z",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5199 37.7562H29.8691V31.0002H34.5199M34.5199 37.7562V31.0002M34.5199 37.7562L38.0943 41.8513C38.4334 42.2399 38.967 42.407 39.4727 42.2829L39.5054 42.2748C40.4285 42.0482 40.8443 40.9919 40.3165 40.2144L38.6477 37.7562H41.7851C42.6533 37.7562 43.3045 36.9761 43.1343 36.14L42.3087 32.0864C42.1801 31.4548 41.6154 31.0002 40.9595 31.0002H34.5199",
    stroke: "#FF739D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInaccurateContent72);
export default __webpack_public_path__ + "static/media/inaccurate-content-72.6a87d6b2.svg";
export { ForwardRef as ReactComponent };